import { useCallback } from 'react';

import { useRemoveSectionFromTemplate } from 'react-hooks';

import type { MutationContext } from './mutationLane';

export type HideSectionInput = {
  channelId: string;
  templateId: string;
  sectionId: string;
};

export type HideSection = (
  input: HideSectionInput,
  context: MutationContext
) => Promise<number>;

// `context.baseVersion` is not sent yet: it is the hook point for the
// expected version (TS-55794)
export function useHideSection(): HideSection {
  const { removeSectionFromTemplate } = useRemoveSectionFromTemplate();

  return useCallback<HideSection>(
    async input => {
      const { newVersion } = await removeSectionFromTemplate(input);

      return newVersion;
    },
    [removeSectionFromTemplate]
  );
}
